import React, {FC, ReactNode} from 'react';

import Box from '@material-ui/core/Box';
import Paper from '@material-ui/core/Paper';
import {PaperProps} from '@material-ui/core';
import {makeStyles} from '@material-ui/core/styles';
import {Theme as DefaultTheme} from '@material-ui/core/styles/createMuiTheme';
import {getDirectionStyles} from '../../utils/ThemeUtils';

import ExpandLessIcon from '@material-ui/icons/ExpandLess';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

export interface GlobalSelectButtonProps extends PaperProps {
    children: ReactNode;
    startAdornment?: ReactNode;
    endAdornment?: ReactNode;
    open?: boolean;
}

const useStyles = makeStyles<DefaultTheme, GlobalSelectButtonProps, string>(theme => ({
    root: {
        display: 'flex',
        alignItems: 'center',

        width: '100%',
        height: '40px',

        cursor: 'pointer',
        padding: theme.spacing(0, 2),
        backgroundColor: 'transparent',

        border: props =>
            props.open
                ? `1px solid ${theme.palette.text.secondary}`
                : `1px solid ${theme.palette.background.overlays}`,

        '&> span': {
            fontSize: '16px !important',
            margin: getDirectionStyles(theme.direction)(
                theme.spacing(0, 0, 0, 2),
                theme.spacing(0, 2, 0, 0)
            )
        },

        // Expand icon
        '& svg:last-of-type': {
            fontSize: '1.5rem',
            color: theme.palette.text.secondary
        },

        [theme.breakpoints.up('fmd')]: {
            padding: theme.spacing(0, 2)
        }
    }
}));

const RadioInput: FC<GlobalSelectButtonProps> = (props: GlobalSelectButtonProps) => {
    const {children, startAdornment, endAdornment, open, ...restProps} = props;

    const classes = useStyles(props);

    const handleKeyDown = event => {
        if (event.key === 'Enter') {
            props.onClick(event);
        }
    };

    return (
        <Paper
            aria-label="button"
            tabIndex={0}
            onKeyDown={handleKeyDown}
            {...restProps}
            classes={classes}>
            {startAdornment}
            {children}
            <Box ml="auto" />
            {endAdornment}
            {open ? <ExpandLessIcon /> : <ExpandMoreIcon />}
        </Paper>
    );
};

export default RadioInput;
